"use client";

import React, { useId } from "react";

const BREAKPOINTS = ["xs", "sm", "md", "lg", "xl", "xxl"];

const BP_MIN_WIDTH = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

function toPercent(cols) {
  return `${(cols / 12) * 100}%`;
}

/**
 * Col - grid column using inline media-query styles.
 * Supports xs, sm, md, lg, xl, xxl with number (1-12) or "auto".
 */
export function Col({ children, className = "", ...props }) {
  const { xs, sm, md, lg, xl, xxl, style: userStyle, ...rest } = props;
  const uid = useId().replace(/:/g, "");
  const colId = `col-${uid}`;

  const bpValues = { xs, sm, md, lg, xl, xxl };
  const hasSizes = BREAKPOINTS.some((bp) => bpValues[bp] !== undefined);

  let cssRules = "";

  if (hasSizes) {
    for (const bp of BREAKPOINTS) {
      const val = bpValues[bp];
      if (val === undefined) continue;

      const minW = BP_MIN_WIDTH[bp];
      let rule;

      if (val === "auto" || val === "content") {
        rule = `  .${colId} { flex: 0 0 auto; width: auto; }`;
      } else if (typeof val === "number" && val >= 1 && val <= 12) {
        rule = `  .${colId} { flex: 0 0 auto; width: ${toPercent(val)}; }`;
      } else {
        continue;
      }

      if (minW === 0) {
        cssRules += rule + "\n";
      } else {
        cssRules += `@media (min-width: ${minW}px) {\n${rule}\n}\n`;
      }
    }
  }

  const baseStyle = hasSizes
    ? {} 
    : { flex: "1 1 0%", minWidth: 0 };

  return (
    <>
      {cssRules && <style dangerouslySetInnerHTML={{ __html: cssRules }} />}
      <div
        className={`px-[15px] ${colId} ${className}`.trim()}
        style={{ ...baseStyle, ...userStyle }}
        {...rest}
      >
        {children}
      </div>
    </>
  );
}
